var swiper
import '../styles/index.scss'

//import $ from 'jquery'
import 'animate.css';
import App from './app.js'
import Mobile from './mobile.js'

document.addEventListener('DOMContentLoaded', function () {
  let Page = new App(swiper)
  let MobilePage = new Mobile()
  Page.init()
  MobilePage.init()
});
